<template>
  <div class="nd-page">
    <header class="nd-page-header">
      <div>
        <h1 id="title" class="page-title">DSD</h1>
        <p class="nd-page-kicker">Planejamentos digitais do sorriso e imagens clínicas.</p>
      </div>
      <v-btn type="button" color="primary" outlined elevation="0" to="/dsd/imagens">
        Imagens
      </v-btn>
    </header>

    <module-stat-grid module="dsd" :items="dataList.data" :count="dataList.count" />

    <v-card class="nd-section-card">
      <div class="nd-table-toolbar">
        <div>
          <div class="nd-table-toolbar__title">DSD</div>
          <div class="nd-table-toolbar__subtitle">Filtre planejamentos por nome ou paciente.</div>
        </div>
        <v-form class="nd-table-toolbar__actions nd-table-toolbar__actions--wide" @submit.prevent="load()">
          <v-btn type="button" color="primary" outlined elevation="0" to="/dsd/imagens">
            <v-icon left size="18">mdi-image-multiple-outline</v-icon>
            Imagens
          </v-btn>
          <v-text-field
            dense
            id="filterName"
            placeholder="Buscar planejamento"
            prepend-inner-icon="mdi-magnify"
            v-model="dataList.filter.name" hide-details="auto"
            outlined
          ></v-text-field>
          <v-text-field dense id="filterPatient" placeholder="Paciente" v-model="dataList.filter.patientName" hide-details="auto" outlined></v-text-field>
          <v-btn id="btnFilter" type="submit" outlined color="primary" elevation="0">
            <v-icon left size="18">mdi-filter-outline</v-icon>
            Filtrar
          </v-btn>
        </v-form>
      </div>
            <v-data-table
              :headers="dataList.headers"
              :items="dataList.data"
              :server-items-length="dataList.count"
              :loading="dataList.loading"
              no-data-text="Nenhum dsd foi encontrado"
              loading-text="Carregando dados..."
              class="app-table hover-table"
              :options.sync="dataList.options"
              :footer-props="dataList.footerOptions"
              @update:options="onTableOptionsChanged"
            >
              <template v-slot:[`item.name`]="{ item }">
                <div class="nd-entity-cell">
                  <span class="nd-entity-mark">{{ item.name ? item.name.charAt(0) : "D" }}</span>
                  <div>
                    <strong>{{ item.name }}</strong>
                    <small>ID {{ item.id }}</small>
                  </div>
                </div>
              </template>

              <template v-slot:[`item.patient`]="{ item }">
                {{ item.patient?.name || 'N/A' }}
              </template>


              <template v-slot:[`item.date`]="{ item }">
                {{ item.date ? new Date(item.date).toLocaleDateString('pt-BR') : 'N/A' }}
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <div class="row-actions">
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn icon small v-on="on" @click="deleteItem(item)">
                        <v-icon size="19">mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Remover DSD</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn icon small v-on="on" @click="viewItem(item)">
                        <v-icon size="19">mdi-eye-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar DSD</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ModuleStatGrid from "@/components/ModuleStatGrid.vue";
import Vue from "vue";
import VueLodash from "vue-lodash";
import _ from "lodash";
import axios from "axios";


Vue.use(VueLodash, { lodash: _ });

export default {
  components: { ModuleStatGrid },
  name: "DsdList",

  data: () => ({
    dataList: {
      filter: {
        name: "",
        patientName: "",
      },
      headers: [
        { text: "Planejamento", value: "name" },
        { text: "Paciente", value: "patient" },
        { text: "Data", value: "date" },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      data: [],
      loading: false,
      count: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      footerOptions: {
        itemsPerPageText: "Itens por página:",
        itemsPerPageOptions: [10, 20, 30, 40, 50],
        pageText: "{0}-{1} de {2}",
      },
    },
  }),


  created() {
   
  },

  computed: {
    lastRecordDate() {
      const latest = this.dataList.data.find((item) => item.date);
      return latest ? new Date(latest.date).toLocaleDateString("pt-BR") : "-";
    },
  },

  methods: {
    onTableOptionsChanged(options) {
      this.dataList.options = { ...options };
      this.load(); 
    },

    clearFilters() {
      this.dataList.filter.name = "";
      this.dataList.filter.patientName = "";
      this.dataList.options.page = 1; 
      this.load();
    },

    async load() {
      this.dataList.loading = true;

      const filterParams = {};
      for (const key in this.dataList.filter) {
        if (this.dataList.filter[key]) { 
          filterParams[key] = this.dataList.filter[key];
        }
      }

      const { page, itemsPerPage } = this.dataList.options;
      const limit = itemsPerPage || 10;
      const params = {
        start: (page - 1) * limit,
        limit,
        ...filterParams, 
      };

      Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);

      try {
        const response = await axios.get('/dsd', { params });

        this.dataList.data = (response.data.data || []).map(this.normalizeDsd);
        this.dataList.count = response.data.count;

      } catch (error) {
        console.error('Erro ao carregar DSDs: ', error);
        if (this.$dialog && this.$dialog.notify) {
          this.$dialog.notify.error('Erro ao carregar DSDs.', { position: 'top-right', timeout: 5000 });
        } else {
          alert('Erro ao carregar DSDs. Verifique o console para mais detalhes.');
        }
      } finally {
        this.dataList.loading = false;
      }
    },

    viewItem(item) {
      this.$router.push(`dsd/${item.id}`);
    },

    normalizeDsd(item) {
      return {
        ...item,
        patient: item.patient || (item.patientId && typeof item.patientId === "object" ? item.patientId : null),
        resource: item.resource || (item.resourceId && typeof item.resourceId === "object" ? item.resourceId : null),
      };
    },

    async deleteItem(item) {
      const confirm = await this.$dialog.confirm({
        text: `Tem certeza que deseja remover o DSD de "${item.name}"?`,
        title: 'Confirmar Exclusão',
        actions: {
          false: 'Cancelar',
          true: { text: 'Excluir', color: 'error' },
        },
      });

      if (confirm) {
        try {
          this.dataList.loading = true;
          await axios.delete(`/dsd/${item.id}`);
          this.$dialog.notify.success('DSD removido com sucesso!', { position: 'top-right', timeout: 3000 });
          this.load();
        } catch (error) {
          console.error('Erro ao remover DSD: ', error);
          if (this.$dialog && this.$dialog.notify) {
            this.$dialog.notify.error('Erro ao remover DSD.', { position: 'top-right', timeout: 5000 });
          }
        } finally {
          this.dataList.loading = false;
        }
      }
    },
  },
};
</script>
